<template name="fade">
  <modal
    v-if="showCustomizeModal"
    :title="$t('OrderCurrent.customize_table_layout')"
    @close-request="onCancel"
    closable
  >
    <div class="mx-3 modal-cont">
      <label class="mb-2">
        {{ $t('OrderCurrent.select_columns') }}
      </label>

      <multi-select
        :options="columns"
        :selected-options="selectedColumns"
        :multiple="true"
        @select="onSelect"
        @remove="onRemove"
        class="m-b"
        placeholder="Select columns"
      />

      <div class="d-flex justify-content-end mt-4">
        <button
          class="btn btn-secondary mr-2"
          @click="onCancel"
        >
          {{ $t('General.cancel') }}
        </button>

        <button
          class="btn btn-primary"
          @click="onSave"
          :disabled="!selectedColumns.length"
        >
          {{ $t('General.save') }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import { MultiSelect } from 'vue-search-select'

export default {
  name: 'CustomizeTableLayout',

  components: {
    Modal,
    MultiSelect
  },

  props: {
    showCustomizeModal: {
      type: Boolean,
      required: true
    },
    columns: {
      type: Array,
      required: true,
      default: () => []
    },
    initalSelections: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      selectedColumns: [...this.initalSelections]
    }
  },

  watch: {
    initalSelections (val) {
      this.selectedColumns = [...val]
    }
  },

  methods: {
    onSelect (list) {
      this.selectedColumns = list
    },

    onRemove (item) {
      this.selectedColumns = this.selectedColumns.filter(
        col => col.text !== item.text
      )
    },

    onSave () {
      this.$emit('saveTableCustomizations', this.selectedColumns)
    },

    onCancel () {
      this.selectedColumns = [...this.initalSelections]
      this.$emit('closeCustomizeTable')
    }
  }
}
</script>

<style>
    .modal-cont {
        width: 95%;
        margin: 0 auto;
        margin-top: 20px;
    }
    .m-b {
        margin-bottom: 25%;
    }
</style>
